
/* @ngInject */
export default function officesTableController($state, OfficesFactory, $scope) {
    const vm = this;

    vm.officesList = [];

    vm.officesHeader = '';
    vm.loadingOffices = true;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.viewOffice = function (office) {
        $state.go('accounts', { accountsPage: 'offices', accountId: office.ContractorId });
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        getOfficeLocations();
    }

    function getOfficeLocations() {
        vm.loadingOffices = true;
        OfficesFactory.getOffices().then((response) => {
            vm.officesList = response.data.Data;
            buildOfficeTableHeader();
            vm.loadingOffices = false;
        });
    }

    function buildOfficeTableHeader() {
        if (vm.officesList.length > 1) {
            vm.officesHeader = 'Offices'; // HPF-233 removing "California" from the "offices" title page
        } else {
		    vm.officesHeader = 'Office'; // HPF-233 removing "California" from the "offices" title page
        }
    }

    $scope.$on('refreshOffices', () => {
        getOfficeLocations();
    });
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/officesTable/officesTableController.js